
  import React from "react"
  import Component from "/home/travis/build/bemayr/photography/src/layouts/index.tsx"
  import data from "/home/travis/build/bemayr/photography/.cache/json/layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js